import httpClient from "@plugins/http";
import { ApiResponse } from "./api";
import { ResourceUserPermissions } from "@/types/resource";

const fetchAssignmentUserPermissions = async ({
  uuid,
  assignmentUuid,
}): Promise<ApiResponse<ResourceUserPermissions>> => {
  return await httpClient.get(`/apis/assignment-lesson/lesson/get-permissions/${uuid}`, {
    params: {
      assignmentUuid: assignmentUuid,
      t: new Date().getTime().toString(),
    },
  });
};

const fetchAssignmentLesson = ({ uuid, assignmentUuid }) => {
  return httpClient.get(`/apis/assignment-lesson/lesson/${uuid}`, {
    params: {
      assignmentUuid: assignmentUuid,
    },
  });
};

export default {
  fetchAssignmentUserPermissions,
  fetchAssignmentLesson,
};
